import { useQuery } from '@tanstack/react-query';
import {
  IGetAllSubmissionRequest,
  IGetAllSubmissionRequestBody,
} from "../../utils/types";
import { apiManager } from "../api-manager";
import { apiClient } from '../api-manager-instance';
import { ENDPOINTS } from '../endpoints';

export const getAllSubmissionRequests = async (
  params: IGetAllSubmissionRequestBody
) => {
  const res = await apiManager.get<IGetAllSubmissionRequest>(
    "/admin/request/all",
    params
  );
  return res;
};


export const useGetAllSubmissionRequests = (params: IGetAllSubmissionRequestBody) =>
  useQuery({
    queryKey: ["get_all_submission_requests", params],
    queryFn: async (): Promise<IGetAllSubmissionRequest> => {
      const res = await apiClient.get(ENDPOINTS.SUBMISSION_REQUEST.GET_ALL, { params });
      return res.data;
    },
  });